module.exports = {
  firebaseProjectId: 'birder-7c2ac',
  firebaseCredentialsFile: __dirname + '/firebase-credentials.json',
  firebaseApiKey: 'AIzaSyCjwBRWdMMZGCx_QryxOzjPGBAMoqd4bAk',
  firebaseStorageBucket: 'birder-7c2ac.appspot.com',
  firestoreURL: 'https://birder-7c2ac.firebaseio.com',
  firebaseMessageSenderId: '261441833609',
  authDomain: 'birdergame.com',
  // Firebase Hosting custom link domain for email-link auth (ActionCodeSettings.linkDomain).
  // Must be configured on this project in Console → Hosting; see Firebase email-link docs.
  firebaseAuthEmailLinkDomain: 'birdergame.com',
  sentryDsn: 'https://e2f0aebeccac4650a1ae09e1173183b6@sentry.io/1516969',
  firebaseAppId: '1:261441833609:web:076174b68417ac29fb1458',

  // sendLoginEmail Cloud Function (Mailtrap + Admin email link)
  loginEmailAppBaseUrl: 'https://birdergame.com',
  mailtrapApiKey: 'fb9d37343ee01f5c1cc79bdbedffb360',
}
